// extracted by mini-css-extract-plugin
module.exports = {"player":"styles_player__D9Htw"};